import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import api from '../../utils/api';
import AllVendor from '../../component/allvendor/AllVendor'
import UserHeader from '../../component/reusable/UserHeader';
import { setSubcategoryRefresh } from '../../redux/subcategories/getAllSubcategorySlice';
import Cards from '../../component/reusable/Cards';
import AllWizardEnqTable from '../../component/wizardComps/AllWizardEnqTable';
import ToolCards from '../../component/reusable/ToolCards';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';
import BomTab from '../../component/bomComps/BomTab';
import AllBomEnqTable from '../../component/bomComps/AllBomEnqTable';
import { exportwizardThunk, getAllwizardThunk, getwizardStatisticsThunk, setwizardFromDate, setwizardPage, setwizardSearch, setwizardSelectedTab, setwizardToDate } from '../../redux/wizardSlice';
import BomFilter from '../../component/bomComps/BomFilter';
import BomStatistics from '../../component/bomComps/BomStatistics';
import { deleteexcessThunk, exportexcessThunk, getAllexcessThunk, getexcessStatisticsThunk, setexcessFromDate, setexcessPage, setexcessSearch, setexcessSelectedTab, setexcessToDate } from '../../redux/excessSlice';



function ExcessEnquires() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('desc')
    const [selectedId, setSelectedId] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);


    //delete
    const deleteCategory = (password) => {
        dispatch(deleteexcessThunk({ id: selectedId, password }))
        setIsModalOpen(false);
    }


    //delete modal open
    const handleDeleteClick = (id) => {
        setIsModalOpen(true);
        setSelectedId(id)
    };

    const handleChange = (event, newValue) => {
        dispatch(setexcessSelectedTab(newValue))
        setAllStatus('')
        dispatch(setexcessPage(1))
        dispatch(setexcessSearch(''))
        dispatch(setexcessFromDate(''))
        dispatch(setexcessToDate(''))
    };

    const { excessenquiry, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab, excessenquiryStatistics } = useSelector((state) => state.excess);
    const excessdData = excessenquiry?.data
    const totalPages = excessenquiry?.totalPages
    const totalItems = excessenquiry?.totalItems
    const itemsPerPage = excessenquiry?.limit

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'QUOTED' : selectedTab === 3 ? 'COMPLETED' : "DELETED"

    // console.log(bom);
    useEffect(() => {
        dispatch(getexcessStatisticsThunk())
    }, [])

    useEffect(() => {
        dispatch(getAllexcessThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate]);


    // Status values offered in the Status column menu (only on the "All" tab, the other tabs are already one status)
    const statusFilterOptions = [{ value: 'NEW', label: 'New' }, { value: 'QUOTED', label: 'Quoted' }, { value: 'COMPLETED', label: 'Completed' }];

    const handleStatusFilter = (value) => {
        setAllStatus(value)
        dispatch(setexcessPage(1))
    };

    // Date / Status column menus: pick descending / ascending explicitly and start again from page 1
    const handleColumnSort = (field, direction) => {
        setSortyBy(field)
        setOrder(direction)
        dispatch(setexcessPage(1))
    };

    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportbomenq = async () => {
        const status = await dispatch(exportexcessThunk(`?limit=${100000}`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data);

            const exportOrderData = status?.payload?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'Name': item?.user?.fullName || '-',
                'Company': item?.user?.companyName || '-',

                'products': item?.productCount + 'products',

                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "excessd")
        }
    }




    return (
        <>
            <UserHeader
                index="Excess Enquiries"
                root="Dashboard"
                exportData={exportbomenq}
                exportLoading={exportLoading}
                hideadd={'hide'}
            />
            <BomStatistics
                statistics={excessenquiryStatistics}
            />
            <Box>
                <BomTab handleChange={handleChange} selectedTab={selectedTab} />
                <BomFilter
                    setAllStatus={setAllStatus}
                    search={search}
                    setSearch={setexcessSearch}
                    setFromDate={setexcessFromDate}
                    setToDate={setexcessToDate}
                    selectedTab={selectedTab}
                />
                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {excessdData?.length > 0 ?
                                    <Typography>
                                        <AllBomEnqTable
                                            bomData={excessdData}
                                            page={page}
                                            setPage={setexcessPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                            dateOrder={sortBy === 'createdAt' ? order : null}
                                            onDateSort={(direction) => handleColumnSort('createdAt', direction)}
                                            statusOrder={sortBy === 'status' ? order : null}
                                            onStatusSort={(direction) => handleColumnSort('status', direction)}
                                            statusFilterOptions={selectedTab === 0 ? statusFilterOptions : null}
                                            statusFilterValue={allStatus}
                                            onStatusFilterChange={handleStatusFilter}
                                            selectedTab={selectedTab}
                                            enquiryType={"Excess inventory"}
                                            handleDeleteClick={handleDeleteClick}
                                            deleteCategory={deleteCategory}
                                            setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen}
                                            path={'/excess/excessEnquiresDetails'}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>

            </Box>
        </>
    );
}

export default ExcessEnquires;
